const state = {
  isExpand: false,
  login: {
    formPosition: 'center',
  }
}

const mutations = {
  toggleExpand(state: any, bool?: boolean) {
    bool === undefined
      ? (state.isExpand = !state.isExpand)
      : (state.isExpand = bool)
  }
}

const actions = {}

export default { state, mutations, actions, namespaced: true }
